var a=class extends HTMLElement{constructor(){super();this.attachShadow({mode:"open"})}play(){this.style.setProperty("--play-state","running")}pause(){this.style.setProperty("--play-state","paused")}connectedCallback(){let n=this.hasAttribute("paused"),t=+this.getAttribute("box-count")||4,e=+this.getAttribute("duration")||Math.sqrt(t/4),s=new Array(t).fill(),o=e/(t*.7),i=100*o,p=`
            content: "";
            position: absolute;
            display: block;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            border: var(--pbp-loading-border, 1px solid white);
            border-width: $WIDTH;
            animation: $DIM ${e}s backwards alternate infinite;
            animation-delay: var(--delay);
            animation-play-state: var(--play-state);
        `;this.shadowRoot.innerHTML=`
            <style>
                :host {
                    display: inline-block;
                    --play-state: ${n?"paused":"running"};
                }
                div {
                    display: grid;
                    grid-template-columns: ${s.map(()=>"1fr").join(" ")};
                    grid-gap: var(--pbp-loading-gap, 8px);
                }
                span {
                    display: inline-block;
                    position: relative;
                    height: var(--pbp-loading-box-size, 20px);
                    width: var(--pbp-loading-box-size, 20px);
                }
                @keyframes x {
                  0% {
                      transform: scaleX(var(--pbp-loading-grow, 150%));
                      opacity: 0;
                  }
                  ${i}% {
                      transform: scaleX(100%);
                      opacity: 1;
                  }
                }
                @keyframes y {
                  0% {
                      transform: scaleY(var(--pbp-loading-grow, 150%));
                      opacity: 0;
                  }
                  ${i}% {
                      transform: scaleY(100%);
                      opacity: 1;
                  }
                }
                span::before {
                    ${p.replace("$WIDTH","1px 0 1px 0").replace("$DIM","y")}
                }
                span::after {
                    ${p.replace("$WIDTH","0 1px 0 1px").replace("$DIM","x")}
                }
                */
            </style>
            <div>
                ${s.map((d,r)=>`<span style="--delay:${r*o}s"></span>`).join("")}
            </div>
        `}};customElements.define("pbp-loading",a);export{a as default};
